import { createContext } from "react";
export const CamperContext = createContext();